import target from "@assets/icons/menus/target.png"
import { IconImageM } from "@common/components/icons/IconsM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import moment from "moment"
import React from "react"
import { View } from "react-native"
import { PrioritizedSchoolSubjects } from "../../tutor/students/ProfilDetails"
import { useSelector } from "react-redux"

export const ProfileInfo = ({
    user,
    showEmail,
    showMobile,
    showSchoolSubjects = false,
    showSupportGoal = false,
    dateFormat = "MMM YYYY",
    style,
}) => {

    const serverTimezone = useSelector((state) => state.data.staticData?.server_timezone)

    const isTzDifferentThanServer =
        !!user?.timezone &&
        !!serverTimezone &&
        user?.timezone !== serverTimezone

    return (
        <View
            style={{
                width: "80%",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                marginBottom: 20,
                ...style,
            }}
        >
            {showEmail && (
                <TextM color={theme.colors.light} style={{ marginTop: 0 }} wrap>
                    {user?.email}
                </TextM>
            )}
            {showMobile && (
                <TextM color={theme.colors.light} style={{ marginTop: 0 }} wrap>
                    {user?.mobile}
                </TextM>
            )}
            {user?.profile?.class && (
                <TextM style={{ marginTop: 5 }} wrap>
                    {user?.profile?.class}
                </TextM>
            )}
            {showSchoolSubjects && user?.prioritized_school_subjects && (
                <PrioritizedSchoolSubjects
                    student={user}
                    style={{ marginTop: 5 }}
                />
            )}
            {showSupportGoal && user?.profile?.support_goal && (
                <View
                    style={{
                        borderRadius: 10,
                        borderWidth: 1,
                        borderColor: theme.colors.lightMore,
                        marginRight: 5,
                        paddingVertical: 8,
                        paddingHorizontal: 8,
                        maxWidth: 360,
                    }}
                >
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                        }}
                    >
                        <IconImageM source={target} width={20} />
                        <TextM
                            style={{ marginLeft: 4 }}
                            fontWeight={"SemiBold"}
                            fontSize={16}
                            wrap
                        >
                            Objectif de l'accompagnement
                        </TextM>
                    </View>
                    <TextM
                        style={{ marginTop: 4 }}
                        fontSize={14}
                        wrap
                        fontWeight={"Regular"}
                    >
                        {user?.profile?.support_goal}
                    </TextM>
                </View>
            )}
            <TextM style={{ marginTop: 5 }} fontWeight="Light" wrap>
                Membre depuis {moment(user?.created_at).format(dateFormat)}
            </TextM>
            {isTzDifferentThanServer && <TextM style={{ marginTop: 5 }} fontWeight="Light" wrap>
                Fuseau horaire actuel : {user?.timezone}
            </TextM>}
        </View>
    )
}
